import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';


// import { CssVarsProvider } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';
// import CssBaseline from '@mui/joy/CssBaseline';
import { Toaster } from 'sonner';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import MainFrame from './components/MainFrame';
import { RootStoreContext } from './stores/root_store';
import { ServiceWorkerProvider } from './contexts/service_worker_context';


import { AuthProvider } from './contexts/auth_context';
import { SocketProvider } from './contexts/socketio_context';
import { RolesProvider } from './contexts/roles_context';
import { UserIdentityProvider } from './contexts/user_identity_context';
import { IdentityProvider } from './contexts/identity_context';
import { IncomingPhoneNumberProvider } from './contexts/incoming_phone_number_context';
import { InfoProvider } from './contexts/info_context';
import { RecentsProvider } from './contexts/recents_context';
import { ShiftHistoryProvider } from './contexts/shift_history_context';
import { MessagesProvider } from './contexts/messages_context';
import { ClockProvider } from './contexts/clock_context';
import { ProjectProvider } from './contexts/project_context';
import { FunProvider } from './contexts/fun_context';
import { PhoneProvider } from './contexts/phone_context';
import { CollabsProvider } from './contexts/collabs_context';
import { MutualProvider } from './contexts/mutual_context';
import { CollabInviteProvider } from './contexts/collab_invite_context';
import { CollaboratorsProvider } from './contexts/collaborators_context';
import { DedicatedAssignmentProvider } from './contexts/dedicated_assignment_context';
import { SidebarProvider } from './contexts/sidebar_context';
import { UserProvider } from './contexts/user_context';
import { DeviceProvider } from './contexts/device_context.tsx';
import { EmailProvider } from './contexts/email_context';
import { RealtimeProvider } from 'contexts/realtime_context';
import { BioProvider } from 'contexts/bio_context';
import { SubscriptionProvider } from 'contexts/subscription_context';
import { RatingProvider } from 'contexts/rating_context';
import { FileProvider } from 'contexts/file_context';
import { FileAssociationProvider } from 'contexts/file_association_context';
import { FHRequestProvider } from 'contexts/fhrequest_context';
import { RequestDelayProvider } from 'contexts/request_delay_context';
import { FHRequestMessageProvider } from 'contexts/fhrequest_message_context';
import { CallIncomingProvider } from 'contexts/call_incoming_context.tsx';
import { CalendarEventProvider } from 'contexts/calendar_event_context';
import { SortableProvider } from 'contexts/sortable_context';
import { WorkItemProvider } from 'contexts/work_item_context';
import { CalendarAuthProvider } from 'contexts/calendar_auth_context';
import { TeamProvider } from 'contexts/team_context';
import { TeamInviteProvider } from 'contexts/team_invite_context';
import { ChatRoomProvider } from 'contexts/chat_room_context';

import {
    experimental_extendTheme as materialExtendTheme,
    Experimental_CssVarsProvider as MaterialCssVarsProvider,
    THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/material/CssBaseline';


const materialTheme = materialExtendTheme();


export default function App() {
    const rootStore = useContext(RootStoreContext);
    const { currentConvoKey } = useParams();

    React.useEffect(() => {
        if (!rootStore.convoStore.currentConvoKey && currentConvoKey) {
            rootStore.convoStore.currentConvoKey = currentConvoKey;
        }
    }, [rootStore.convoStore, currentConvoKey]);


    if (!import.meta.env.PROD) {
        const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
        if (link) {
            link.href = '/f-logo-grad.DEV.svg';
        }
        const manifest: HTMLLinkElement | null = document.querySelector("link[rel*='manifest']");
        if (manifest) {
            manifest.href = '/manifest.DEV.json';
        }
    }

    return (
        <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }} defaultMode="system" >
            <JoyCssVarsProvider defaultMode="system">
                <GlobalStyles
                    styles={(theme) => `
        [data-sonner-toaster][data-theme] {
          font-family: ${theme.vars.fontFamily.body};
          font-size: ${theme.fontSize.md};
          --border-radius: ${theme.vars.radius.sm};
          --normal-bg: ${theme.vars.palette.background.surface};
          --normal-border: ${theme.vars.palette.divider};
          --normal-text: ${theme.vars.palette.text.primary};
          --success-bg: ${theme.vars.palette.success.softBg};
          --success-border: rgb(${theme.vars.palette.success.mainChannel} / 0.2);
          --success-text: ${theme.vars.palette.success.softColor};
          --error-bg: ${theme.vars.palette.danger.softBg};
          --error-border: rgb(${theme.vars.palette.danger.mainChannel} / 0.2);
          --error-text: ${theme.vars.palette.danger.softColor};
          --gray1: ${theme.vars.palette.neutral[50]};
          --gray2: ${theme.vars.palette.neutral[100]};
          --gray3: ${theme.vars.palette.neutral[200]};
          --gray4: ${theme.vars.palette.neutral[300]};
          --gray5: ${theme.vars.palette.neutral[400]};
          --gray6: ${theme.vars.palette.neutral[500]};
          --gray7: ${theme.vars.palette.neutral[600]};
          --gray8: ${theme.vars.palette.neutral[700]};
          --gray9: ${theme.vars.palette.neutral[800]};
          --gray10: ${theme.vars.palette.neutral[900]};
        }
        &.sonner-toast-warn {
          --normal-bg: ${theme.vars.palette.warning.softBg};
          --normal-border: rgb(${theme.vars.palette.warning.mainChannel} / 0.2);
          --normal-text: ${theme.vars.palette.warning.softColor};
        }
      `}
                />
                <CssBaseline enableColorScheme />
                <RootStoreContext.Provider value={rootStore}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <AuthProvider>
                            <UserProvider>
                                <RolesProvider>
                                    <IdentityProvider>
                                        <UserIdentityProvider>
                                        <RealtimeProvider>
                                                                <ShiftHistoryProvider>

                                                <SocketProvider>
                                                                        <ChatRoomProvider>
                                                                            <TeamProvider>
                                                                                <TeamInviteProvider>
                                                                                    <SortableProvider>
                                                                                        <WorkItemProvider>
                                                                                            <CalendarAuthProvider>
                                                                                                <RatingProvider>
                                                                                                    <SubscriptionProvider>
                                                                                                        <InfoProvider>
                                                                                                            <BioProvider>
                                                                                                                <DedicatedAssignmentProvider>
                                                                                                                    <DeviceProvider>
                                                                                                                        <ProjectProvider>
                                                                                                                            <CollabsProvider>
                                                                                                                                <CollabInviteProvider>
                                                                                                                                    <CollaboratorsProvider>
                                                                                                                                        <FHRequestProvider>
                                                                                                                                            <RequestDelayProvider>
                                                                                                                                                <FHRequestMessageProvider>

                                                                                                                                                    <ClockProvider>                                                                                                                                                    <MessagesProvider>



                                                                                                                                                        <IncomingPhoneNumberProvider>
                                                                                                                                                            <CallIncomingProvider>
                                                                                                                                                                <RecentsProvider>
                                                                                                                                                                    <MutualProvider>
                                                                                                                                                                        <CalendarEventProvider>
                                                                                                                                                                            <PhoneProvider>
                                                                                                                                                                                <EmailProvider>
                                                                                                                                                                                    <FunProvider>
                                                                                                                                                                                        <SidebarProvider>
                                                                                                                                                                                            <FileProvider>
                                                                                                                                                                                                <FileAssociationProvider>


                                                                                                                                                                                                    <ServiceWorkerProvider>
                                                                                                                                                                                                        <MainFrame />
                                                                                                                                                                                                        <Toaster
                                                                                                                                                                                                            position="bottom-right"
                                                                                                                                                                                                            richColors
                                                                                                                                                                                                            closeButton={false} />
                                                                                                                                                                                                    </ServiceWorkerProvider>


                                                                                                                                                                                                </FileAssociationProvider>
                                                                                                                                                                                            </FileProvider>
                                                                                                                                                                                        </SidebarProvider>
                                                                                                                                                                                    </FunProvider>
                                                                                                                                                                                </EmailProvider>
                                                                                                                                                                            </PhoneProvider>
                                                                                                                                                                        </CalendarEventProvider>
                                                                                                                                                                    </MutualProvider>
                                                                                                                                                                </RecentsProvider>
                                                                                                                                                            </CallIncomingProvider>
                                                                                                                                                        </IncomingPhoneNumberProvider>



                                                                                                                                                    </MessagesProvider>
                                                                                                                                                    </ClockProvider>
                                                                                                                                                </FHRequestMessageProvider>
                                                                                                                                            </RequestDelayProvider>
                                                                                                                                        </FHRequestProvider>
                                                                                                                                    </CollaboratorsProvider>
                                                                                                                                </CollabInviteProvider>
                                                                                                                            </CollabsProvider>
                                                                                                                        </ProjectProvider>
                                                                                                                    </DeviceProvider>
                                                                                                                </DedicatedAssignmentProvider>
                                                                                                            </BioProvider>
                                                                                                        </InfoProvider>
                                                                                                    </SubscriptionProvider>
                                                                                                </RatingProvider>
                                                                                            </CalendarAuthProvider>
                                                                                        </WorkItemProvider>
                                                                                    </SortableProvider>

                                                                                </TeamInviteProvider>
                                                                            </TeamProvider>
                                                                        </ChatRoomProvider>

                                                    </SocketProvider>
                                                                    </ShiftHistoryProvider>

                                            </RealtimeProvider>
                                        </UserIdentityProvider>

                                    </IdentityProvider>

                                </RolesProvider>
                            </UserProvider>

                        </AuthProvider>
                    </LocalizationProvider>
                </RootStoreContext.Provider>

            </JoyCssVarsProvider>

        </MaterialCssVarsProvider>
    );
}
